module.exports = __webpack_public_path__ + "static/media/smhc-left-icon.e31e7754.png";